module.exports = __webpack_public_path__ + "static/img/document-icon.723ee66a.svg";